import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { VehicleAddModalComponent } from './vehicle-add-modal.component';
import { VehicleAddModule } from '../vehicle-add/vehicle-add.module';
import { ValidationResultsModule } from '../../../../../shared/components/validation-results/validation-results.module';
import { MessageService } from 'primeng/api';

@NgModule({
    declarations: [
        VehicleAddModalComponent
    ],
    providers: [
        MessageService
    ],
    imports: [
        CommonModule,
        VehicleAddModule,
        ValidationResultsModule,
        ToastModule
    ]
})
export class VehicleAddModalModule {
}
